import services from '@/config/services'
// import moment from 'moment'

export default class UtilityContrattiVenditaService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async downloadMandatiRidMpsZip(opts){
    const url = `${this.baseUrl}/utility/rid/mandati/mps/flussi-multipli/zip`
  
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: {
          filters: opts,
        },
        responseType: 'blob',
      })
      
      const blob = new Blob([res.data], {type: 'application/zip'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
  
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
}
